import React  from 'react';
import styled from 'styled-components';
import {
  DataTable,
  Dropdown,
  SearchInput,
  SearchPagination,
}             from '@components/index';
import {
  TDataTableRow,
}             from '@typings/components';
import {
  USERS_TABLE_HEADERS,
}             from '../utils/tableHeaders';

const HeaderWrapper = styled.div`
  display         : flex;
  justify-content : space-between;
  align-items     : center;
  width           : 97%;

`;

const SearchWrapper = styled.div`
  width: 500px;

    .MuiOutlinedInput-root {
      border-radius: 20px;
    }
`;

interface IProps {
  tableRows               : TDataTableRow[];
  filterValues            : any;
  handleSelectFilterValue : any;
  selectedFilterValue     : string;
  inputValue              : any;
  handleSearch            : any;
  totalAuctionsCount      : number;
  currentPage             : any;
  handleChangePage        : any;
  rowsPerPage             : number;
}

export const UsersPage = ({
  tableRows,
  filterValues,
  handleSelectFilterValue,
  selectedFilterValue,
  inputValue,
  handleSearch,
  totalAuctionsCount,
  currentPage,
  rowsPerPage,
  handleChangePage,
}: IProps) => (
  <>
    <HeaderWrapper>
      <SearchWrapper>
        <SearchInput
          title        = ""
          labelWidth   = "200px"
          maxWidth     = "700px"
          margin       = "20px 5px 10px"
          handleSearch = {handleSearch}
          withTitle    = {false}
          initialValue = {inputValue}
        />
      </SearchWrapper>

      <Dropdown
        width               = {250}
        field               = {{ value: selectedFilterValue }}
        options             = {filterValues}
        customOnValueChange = {handleSelectFilterValue}
      />
    </HeaderWrapper>

    <DataTable
      headers  = {USERS_TABLE_HEADERS}
      rows     = {tableRows}
      maxwidth = "1280px"
    />

    {!!totalAuctionsCount && (
      <SearchPagination
        totalItems       = {totalAuctionsCount}
        currentPage      = {currentPage}
        rowsPerPage      = {rowsPerPage}
        handleChangePage = {handleChangePage}
        maxWidth         = "100%"
      />
    )}
  </>
);
